import type { ReactNode } from 'react';
import { classes, type Space } from '@src/components/layout/space';
import { testIdAttr } from '@src/components/testId';
import './Cluster.css';

export type ClusterAlign = 'start' | 'center' | 'baseline' | 'end';
export type ClusterJustify = 'start' | 'center' | 'end' | 'between';

export interface ClusterProps {
  children: ReactNode;
  gap?: Space;
  align?: ClusterAlign;
  justify?: ClusterJustify;
  wide?: boolean;
  /** Default wraps. Off keeps a trailing action on the same row. */
  wrap?: boolean;
  /** Column + stretch below 48rem — paired CTAs that go full-width on a phone. */
  stack?: 'narrow';
  rule?: 'bottom';
  as?: 'div' | 'nav' | 'ul' | 'header' | 'footer';
  className?: string;
  testId?: string;
}

export function Cluster({
  children,
  gap = 3,
  align = 'center',
  justify = 'start',
  wide = false,
  wrap = true,
  stack,
  rule,
  as: Tag = 'div',
  className,
  testId,
}: ClusterProps) {
  return (
    <Tag
      className={classes(
        'cluster',
        `cluster--gap-${gap}`,
        `cluster--align-${align}`,
        `cluster--justify-${justify}`,
        wide && 'cluster--wide',
        wrap === false && 'cluster--nowrap',
        stack === 'narrow' && 'cluster--stack-narrow',
        rule === 'bottom' && 'cluster--rule-bottom',
        className,
      )}
      {...testIdAttr(testId)}
    >
      {children}
    </Tag>
  );
}
